import * as React from "react";

import { Form, Button } from "semantic-ui-react";
import { QuestionWrapper } from "@teamprevent/common/questionnaires/components/questions/QuestionWrapper";

import { QuestionProps, AnsweredQuestion } from "../../model";
import { isQuestionDisabled } from "../../questionnaireConfig/models";

interface MultiButtonQuestionAdditionalProps {
    values?: string[];
}

export const YesOption = "Yes";
export const NoOption = "No";

type MultiButtonQuestionProps = QuestionProps & MultiButtonQuestionAdditionalProps;

interface MultiButtonQuestionComponent extends React.SFC<MultiButtonQuestionProps> {
    YesOption: string;
    NoOption: string;
}

const multiButtonQuestion = (props: MultiButtonQuestionProps) => {
    if (isQuestionDisabled(props.questionConfig)) {
        return null;
    }

    return (
        <QuestionWrapper
            mandatory={props.mandatory}
            inline={props.inline}
            question={props.questionConfig.questionText}
            questionElement={props.questionConfig.questionElement}
            hideDivider={props.hideDivider}
            error={props.showError && (props.mandatory && !props.answer && "This field must be completed")}
            questionClassName={props.questionClassName}
            readonly={props.readonly}
            removable={{
                ...props.removable,
                questionId: props.questionConfig.id,
                isRemovedByUser: props.isRemovedByUser
            }}
            outdated={{
                ...props.outdated,
                questionId: props.questionConfig.id
            }}
        >
            <Form.Field>
                {renderValue(props)}
            </Form.Field>
        </QuestionWrapper>
    );
};

const renderValue = (props: MultiButtonQuestionProps) => {
    const onClick = (answer: string) => {
        if (isQuestionDisabled(props.questionConfig)) {
            return;
        }

        const newQuestion: AnsweredQuestion = { question: props.questionConfig.questionText, answer, isValid: !!answer || !props.mandatory };
        props.updateQuestion(newQuestion);
        if (props.onAnswerChange) {
            props.onAnswerChange(newQuestion.answer);
        }
    };

    if (props.readonly) {
        return <div>{props.answer}</div>;
    }
    const values = props.values || [YesOption, NoOption];
    return (
        <Button.Group>
            {
                values
                    .reduce((result, v, i) => {
                    // eslint-disable-next-line react/jsx-no-bind
                        result.push(<Button key={v} type="button" secondary positive={props.answer === v} onClick={() => onClick(v)} content={v} />);
                        if (i < values.length - 1) {
                            result.push(<Button.Or key={`or${i}`} />);
                        }
                        return result;
                    }, [])
            }
        </Button.Group>
    );
};

export const MultiButtonQuestion: MultiButtonQuestionComponent = Object.assign(
    multiButtonQuestion,
    { YesOption, NoOption }
);
